export default __webpack_public_path__ + "static/media/UGC-new1.6f425d51.png";